
import { computed, defineComponent, PropType, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import CardV2 from '@/views/dashboard/_components/card-v2/card-v2.vue'
import Copy from '@/views/_components/copy/copy.vue'
import Countdown from '@/views/_components/countdown/countdown.vue'
import { formatTimeStamp } from '@/utils/time'
import { ServiceList } from '@/views/dashboard/service/buy-more/buy-more.service'
import { DateKindLabel } from '@/views/dashboard/service/_enum/date-kind'
import ServiceEnum from '@/views/dashboard/service/_components/service-enum/service-enum.vue'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'

export default defineComponent({
  components: { ServiceEnum, Countdown, Copy, CardV2 },
  props: {
    productId: {
      type: String,
      default: ''
    },
    propsTableData: {
      type: Array as PropType<ServiceList[]>,
      default: () => ([])
    },
    isPrivate: {
      type: Boolean,
      default: false
    }
  },

  setup (props, context) {
    const { t, te, locale } = useI18n()
    const tableNode = ref()
    const isLoading = ref(false)
    const tableData = ref<ServiceList[]>(props.propsTableData)
    const selectionData = ref<ServiceList[]>([])
    const selectionShot = ref<ServiceList[]>([])
    const isShowSelection = ref(false)
    const isPrivateLike = computed(() => props.isPrivate || IS_JP_ONLY_BUILD)

    const selectedCount = computed(() => {
      return selectionData.value.length
    })

    function handleCancelSelect () {
      tableNode.value.clearSelection()
      toggleShowSelected(false)
    }

    function handleSelectionChange (values: ServiceList[]) {
      selectionData.value = values
      context.emit('changeSelect', selectionData.value.map(v => v.price_id), selectionData.value)
    }

    /**
     * 切换展示已选数据
     * @param show 如果使用了show参数，则是切换到指定状态。不设置表示切换反状态
     */
    function toggleShowSelected (show?: boolean) {
      isShowSelection.value = typeof show === 'boolean' ? show : !isShowSelection.value
      if (isShowSelection.value) {
        selectionShot.value = [...selectionData.value]
        updateSelectionShow()
      } else {
        tableData.value = props.propsTableData
      }
    }

    function updateSelectionShow () {
      tableData.value = selectionShot.value
    }

    function serviceDisplayName (item: ServiceList) {
      void locale.value
      const id = item.price_id
      if (id == null) return item.display_name || ''
      const key = `mySubscribe.priceTitle.${id}`
      return te(key) ? String(t(key)) : (item.display_name || '')
    }

    watch(() => props.propsTableData, () => {
      tableData.value = props.propsTableData
      tableNode.value.toggleAllSelection()
    })

    return {
      DateKindLabel,
      tableNode,
      tableData,
      isPrivateLike,
      selectedCount,
      isShowSelection,
      handleCancelSelect,
      formatTimeStamp,
      handleSelectionChange,
      toggleShowSelected,
      serviceDisplayName,
    }
  }
})
